if ($('.reviewsInner').length) {
  const storageKey = 'storeRatingData-' + document.location.host;

  function generateStars(score) {
    const full = Math.floor(score);
    const half = score % 1 >= 0.5;
    let html = '';
    for (let i = 0; i < full; i++) {
      html += '<span class="star star-on"></span>';
    }
    if (half && full < 5) {
      html += '<span class="star star-half"></span>';
    }
    return html;
  }

  function renderRating(data) {
    const d = typeof data === 'string' ? JSON.parse(data) : data;
    const average = parseFloat(d.averageScore) || 0;
    const count = d.count || 0;
    const ratings = d.ratings?.slice(0, 20) || [];    
    const reviewHtml = ratings.map(r => `
      <div class="review-item">
        <div class="inner">
          <div class="header">
            <div class="review-name">${r.fullName || 'Ověřený zákazník'}</div>
            <div class="review-stars"><span class="stars">${generateStars(parseFloat(r.score) || 0)}</span></div>
          </div>
          <div class="review-description">${r.description}</div>
          <div class="review-bottom"><span class="left">${formatDate(r.created.date)}</span><span class="right">Ověřená recenze</span></div>
        </div>
      </div>
    `).join('');

    const reviewTop = `
      <div class="left">${average}</div>
      <div class="right"><p>Ověřené recenze</p><p><a href="/hodnoceni-obchodu/">Zobrazit více jak ${count-1} hodnocení</a></p></div>
    `;

    $('.reviewsInner .top').html(reviewTop);
    $('.reviewsInner .reviewsFeed').html(reviewHtml);

    // Inicializace slick slideru na .reviewsFeed
    $('.reviewsInner .reviewsFeed').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: false,
      autoplay: false,
      autoplaySpeed: 5000,
      dots: false,
      arrows: true,
      infinite: false,
      adaptiveHeight: false,
      responsive: [
        { breakpoint: 1439, settings: { slidesToShow: 4, slidesToScroll: 1 }},
        { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 }},
        { breakpoint: 992,  settings: { slidesToShow: 2, slidesToScroll: 1 }},
        { breakpoint: 767,  settings: { slidesToShow: 2, slidesToScroll: 1, arrows:false, dots:true}},
        { breakpoint: 480,  settings: { slidesToShow: 1, slidesToScroll: 1, arrows:false, dots:true }}
      ]
    });
  }

  const stored = sessionStorage.getItem(storageKey);
  if (stored) {
    renderRating(JSON.parse(stored));
  } else {
    $.ajax({
      url: '/cache/hodnoceni-obchodu/?jsonFormat',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Store-Rating-Details': 'true'
      },
      success: function (response) {
        //console.log(response);
        sessionStorage.setItem(storageKey, JSON.stringify(response));
        renderRating(response);
      },
      error: function (xhr, status, error) {
        console.error('Chyba při načítání hodnocení:', error);
      }
    });
  }

  function formatDate(input) {
    if (!input) return '';
    let date = new Date(input.replace(" ", "T"));
    return date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
  }
}
